import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { DEFAULT_CONTENT_WIDTH } from '@/features/marketplace/constants';
import { EventsHorizontalCarousel } from './components/events-list';
import { eventsData } from './events-data';
import { EventTranslation } from './types';

const CommunityEventsSection = () => {
  const { t } = useTranslation();

  const eventsTranslations = t('js.features.marketplace.home.community_events.events', {
    returnObjects: true,
  }) as Record<string, EventTranslation>;

  return (
    <section className="w-full overflow-hidden bg-white py-10">
      <div className={clsx(DEFAULT_CONTENT_WIDTH, 'm-auto flex-1')}>
        <div className="flex w-full items-center justify-between">
          <h2 className={clsx(
            'text-h3 font-bold text-text-primary',
            'leading-[3.7rem]',
            'sm:text-[4.8rem] sm:leading-[5.5rem]'
          )}>
            {t('js.features.marketplace.home.community_events.title')}
          </h2>
        </div>
      </div>
      <EventsHorizontalCarousel eventsData={eventsData} eventsTranslations={eventsTranslations} />
    </section>
  );
};

export { CommunityEventsSection };
